import { Country } from "../../earth/model/country";
import { Land } from "../../earth/model/land";
import { MetricsLoader } from "../dataAccess/metricsLoader";
import { MetricsByBrand } from "../model/metricsByBrand";
import { MetricsByCountry } from "../model/metricsByCountry";
import { MetricType } from "../model/metricType";

export class MetricsService {
    private static _instance: MetricsService | null = null;

    countryMetrics = new Map<MetricType, MetricsByCountry>();

    static get instance() {
        if (!MetricsService._instance) {
            MetricsService._instance = new MetricsService();
        }
        return MetricsService._instance;
    }

    async loadMetrics(): Promise<void> {
        for (let metricType of MetricType.AllTypes) {
            let metrics = await MetricsLoader.loadMetricsForType(metricType);
            this.countryMetrics.set(metricType, metrics);
        }
    }

    getMetricsWithType(type: MetricType): MetricsByCountry {
        return this.countryMetrics.get(type) || new MetricsByCountry();
    }

    getMetricsForLand(type: MetricType, land: Land): MetricsByBrand {
        let metrics = this.getMetricsWithType(type);
        let countries = land.getLeafChildren() as Country[];
        return metrics.aggregateMetricsForCountries(countries);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/services/metricsService.ts